import { render, staticRenderFns } from "./VisitPasses.vue?vue&type=template&id=edb799d4&"
import script from "./VisitPasses.vue?vue&type=script&lang=js&"
export * from "./VisitPasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports